import moment from "moment";
import { FORMATE } from "../constant/global.constant";

export const convertToLocalDateTime = (dateTime: string) => {
  return moment(dateTime).utc().local().format(FORMATE.DATE_TIME);
};

export const convertToLocalDate = (date: string) => {
  return moment(date).utc().local().format(FORMATE.DATE);
};
